import { PageLayoutService } from './../services/page-layout.service';
import { ComponentListService } from './../services/component-list.service';
import { NgModule, Optional, Inject, Injector } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EditLoader } from '../edit-loader';
import { SharingLibraryModule } from '@pershing/pershing-sharing' ;
import { CommonModule } from '@angular/common';
import { EditLibraryComponentModule } from './component.module';
import { PershingCoreRootModule } from '@pershing/pershing-core';
import { PageStateService } from '../services/page-state.service';

export * from '../tokens/edit-library-options.token';
export * from '../models/componet.model';
export * from '../models/edit-library-options.model';
export * from '../models/library-service-definition';
export * from '../models/page-layout.model';

@NgModule({
    imports: [
        CommonModule,
        SharingLibraryModule,
        EditLibraryComponentModule,
        PershingCoreRootModule,
        TranslateModule
    ],
    providers: [
        PageStateService,
        ComponentListService,
        PageLayoutService
    ]
})
export class EditLibraryModule {
    constructor(private injector: Injector, @Optional() @Inject('AppSettings') private appSettings: any) {
        const loader = new EditLoader(this.injector);
        loader.initialize(this.appSettings);
    }
    public ngDoBootstrap(appRef) {}
}
